export const CLICK_SELECT_USER_INVITE = 'CLICK_SELECT_USER_INVITE';
export const SET_SELECT_USER_INVITE_FALSE = 'SET_SELECT_USER_INVITE_FALSE';

interface ClickSelectAction {
  type: typeof CLICK_SELECT_USER_INVITE;
}

interface SetClickSelectFalseAction {
  type: typeof SET_SELECT_USER_INVITE_FALSE;
}

export const clickSelectUserInvite = (): ClickSelectAction => ({
  type: CLICK_SELECT_USER_INVITE,
});

export const setClickSelectUserInviteFalse = (): SetClickSelectFalseAction => ({
  type: SET_SELECT_USER_INVITE_FALSE,
});

export type ToggleActionTypes = ClickSelectAction | SetClickSelectFalseAction;